import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./contexts/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import SoulJourneyPage from "./pages/SoulJourneyPage";
import ExperiencesPage from "./pages/ExperiencesPage";
import MembershipPage from "./pages/MembershipPage";
import PractitionersPage from "./pages/PractitionersPage";
import PractitionerDetailPage from "./pages/PractitionerDetailPage";
import ReviewsPage from "./pages/ReviewsPage";
import AboutPage from "./pages/AboutPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import McmPage from "./pages/McmPage";
import OngoingSupportPage from "./pages/OngoingSupportPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import LegalPage from "./pages/LegalPage";
import ProfilePage from "./pages/ProfilePage";
import TWNHubProfilePage from "./pages/TWNHubProfilePage";
import MemberDashboard from "./pages/MemberDashboard";
import PractitionerDashboard from "./pages/PractitionerDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLandingPages from "./pages/AdminLandingPages";
import AdminUsersPage from "./pages/AdminUsersPage";
import AdminAnalyticsPage from "./pages/AdminAnalyticsPage";
import LandingPage from "./pages/LandingPage";
import MigratedPage from "./pages/migrated/MigratedPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancelled from "./pages/PaymentCancelled";
import Seo from "./components/Seo";

function App() {
  return (
    <div className="App min-h-screen bg-black text-white">
      <BrowserRouter>
        <AuthProvider>
          <Seo />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/soul-journey" element={<SoulJourneyPage />} />
              <Route path="/experiences" element={<ExperiencesPage />} />
              <Route path="/membership" element={<MembershipPage />} />
              <Route path="/practitioners" element={<PractitionersPage />} />
              <Route path="/practitioners/:practitionerId" element={<PractitionerDetailPage />} />
              <Route path="/frequency-boost" element={<MigratedPage slug="frequency-boost" />} />
              <Route path="/mahalia" element={<MigratedPage slug="mahalia" />} />
              <Route path="/audrina" element={<MigratedPage slug="audrina" />} />
              <Route path="/karnada" element={<MigratedPage slug="karnada" />} />
              <Route path="/micki" element={<MigratedPage slug="micki" />} />
              <Route path="/sovereignty-amplified" element={<MigratedPage slug="sovereignty-amplified" />} />
              <Route path="/after-the-reset" element={<MigratedPage slug="after-the-reset" />} />
              <Route path="/detach-protocol" element={<MigratedPage slug="detach-protocol" />} />
              <Route
                path="/audrina-ongoing-support"
                element={<MigratedPage slug="audrina-ongoing-support" />}
              />
              <Route path="/podcast" element={<MigratedPage slug="podcast" />} />
              <Route path="/aquiera" element={<MigratedPage slug="aquiera" />} />
              <Route path="/ebony" element={<MigratedPage slug="ebony" />} />
              <Route path="/dannielle" element={<MigratedPage slug="dannielle" />} />
              <Route path="/reclaim" element={<MigratedPage slug="reclaim" />} />
              <Route path="/clarify" element={<MigratedPage slug="clarify" />} />
              <Route path="/rise" element={<MigratedPage slug="rise" />} />
              <Route path="/reset-room" element={<MigratedPage slug="reset-room" />} />
              <Route
                path="/goddessiman-ongoing-support"
                element={<MigratedPage slug="goddessiman-ongoing-support" />}
              />
              <Route path="/gordon" element={<MigratedPage slug="gordon" />} />
              <Route path="/goddessiman" element={<MigratedPage slug="goddessiman" />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/how-it-works" element={<HowItWorksPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/privacy-policy" element={<LegalPage documentType="privacy" />} />
              <Route path="/terms-conditions" element={<LegalPage documentType="terms" />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/mcm" element={<McmPage />} />
              <Route
                path="/cindie-ongoing-support"
                element={<OngoingSupportPage practitioner="cindie" />}
              />
              <Route
                path="/aquiera-ongoing-support"
                element={<OngoingSupportPage practitioner="aquiera" />}
              />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/twn-hub-profile" element={<TWNHubProfilePage />} />
              <Route path="/member-dashboard" element={<MemberDashboard />} />
              <Route path="/practitioner-dashboard" element={<PractitionerDashboard />} />
              <Route path="/admin-dashboard" element={<AdminDashboard />} />
              <Route path="/admin/users" element={<AdminUsersPage />} />
              <Route path="/admin/landing-pages" element={<AdminLandingPages />} />
              <Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
              <Route path="/offers/:slug" element={<LandingPage />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/payment-cancelled" element={<PaymentCancelled />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;